import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildPredispositionUrl } from '../../../../containers/common/constant/appUrl'
import { Flag } from '../../../../containers/common/constant/classification'

export const CATEGORY_NAMES = ['predisposition']

interface ChildPredispositionUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
}

export const ChildPredispositionUnit = (props: ChildPredispositionUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const targetCategories = categoryMst
    ?.filter((value) => CATEGORY_NAMES.includes(value.category) && value.displayCitizen === Flag.ON)
  if (targetCategories == null || targetCategories.length === 0) return null
  
  const childPredisposition = child?.predisposition
  const predispositionFlag = childPredisposition?.length
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildPredispositionUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000184 }} hideLink={props.hideLink} />
      <Grid container>
        <GItem xs={12}>{ predispositionFlag ? '登録あり' : '登録なし'}</GItem>
      </Grid>
    </>
  )
}
